import React, {useState } from 'react';
import './JoinOrg.css';
import confetti from 'canvas-confetti';
import DeleteConfirmModal from '../components/DeleteConfirmModal';


// users can create new subscriptions under their current account
export default function NewSubscriptionPage() {

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    companyName: '',
    legalName: '',
    termsAccepted: false,
  });

  
  const [error, setError] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
    }));
  };

  //throw error only if validation fails
  const handleFormValidation = (): {isValid:boolean, error:string} => {
    //TODO:
    
    const {
        email,
        companyName,
        legalName,
        password,
        termsAccepted
    } = formData;

    if (!email || !password || !legalName || !companyName || !termsAccepted) {
        return { isValid: false, error: 'Missing data'}
    }

    return {isValid: true, error: ""}

  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setShowTooltip(false);

    const validation = handleFormValidation();
    if (!validation.isValid) {
      setError(validation.error);
      setShowTooltip(true);
      return;
    }

    setSubmitError(null);
    setConfirmOpen(true);
  };

  const handleConfirmCreate = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/register/tenant/existing`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          companyName: formData.companyName,
          legalName: formData.legalName,
          termsAccepted: formData.termsAccepted,
        }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        setSubmitError(result?.message || 'Something went wrong during registration.');
        setIsSubmitting(false);
        return;
      }

      setIsSubmitting(false);
      setConfirmOpen(false);
      setTimeout(() => {
        confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
        setTimeout(() => {
          window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth`;
        }, 2000);
      }, 100);
    } catch (err: any) {
      setSubmitError(err?.message || 'Network error. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="registration-page-container">
      <form className="join-org-form" onSubmit={handleSubmit} autoComplete="off">
        <h2>New Organization Details</h2>

        <input type='text' name='email' placeholder="Email" value={formData.email} onChange={handleChange} required/>
        <div className="password-tooltip-wrapper">
          <div className="password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              aria-label="Toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-visibility"
            >
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {showPassword ? (
                  <>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                    <circle cx="12" cy="12" r="3" />
                  </>
                ) : (
                  <>
                    <path d="M1 1l22 22" />
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                    <circle cx="12" cy="12" r="3" />
                  </>
                )}
              </svg>
            </button>
          </div>
        </div>

        <input type='text' name='companyName' placeholder="New Company Name" value={formData.companyName} onChange={handleChange} required/>
        <input type='text' name='legalName' placeholder="New Legal Entity Name" value={formData.legalName} onChange={handleChange} required/>

        <label className="terms-label">
          <input type="checkbox" name="termsAccepted" checked={formData.termsAccepted} onChange={handleChange} required />
          I agree to the{' '}
          <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="terms-link">
            Terms and Conditions
          </a>
        </label>

        {!error ? (
          <button className="submit-btn" type="submit" style={{ border: '1px solid white' }}>
            Confirm
          </button>
        ) : (
          <button
            className="back-to-login-btn"
            onClick={(e) => {
              e.preventDefault(); 
              setShowTooltip(false);
              setTimeout(() => {
                window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth`;
              }, 0);
            }}
          >
            Back to Log In
          </button>
        )}
        {showTooltip && (
          <div style={{marginTop:'4px',}} className='tooltip tooltip-error'>
            {error}
          </div>
        )}
      </form>

      <DeleteConfirmModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirmCreate}
        title="Create New Account"
        message='This will create a new account owned by you. If you want to join an existing account, go back and select "Join Existing Account." Do you wish to proceed?'
        confirmLabel={isSubmitting ? 'Creating organization…' : 'Create Account'}
        confirmColor="#1faa59"
        isLoading={isSubmitting}
        error={submitError}
      />
    </div>
  );
}
